import Menu from "./menu";
import moment from "moment";

export default {
  defaultSettings: {
    organizations: {
      type: "local",
      personnelDB: {
        dbType: "mariaDB",
        ip: "",
        port: "",
        user: "",
        password: "",
        database: "",
        table: "",
        column: {
          displayName: "",
          name: "",
          department: [],
          email: "",
          title: "",
          mobile: "",
          telephoneNumber: "",
          sAMAccountName: "",
        },
      },
    },
    license: {
      expDate: "2021-03-31",
      webEx: 200,
      device: 260,
      // cisco: 200,
      // polycom: 200,
      // other: 500
    },
    meetings: {
      meetingRecordInit: false,
      meetingMuteInit: false,
      joinBeforeTime: 0,
      calendarInterval: 60,
      calendarSlotCnt: 2,
      workStartHour: "09:00",
      workEndHour: "18:00",
      savingCost: 1000,
      useRoomMeeting: true,
    },
    webex: {
      useBot: false,
      botKey: "",
    },
    smtp: {
      fromEmail: "",
      host: "",
      port: "",
      userName: "",
      password: "",
      passwordConfirm: "",
    },
    systems: {
      mainPage: "my-meeting",
      isDashboardDetail: false,
      isUserViewRecordFiles: false,
      notice: "",
      noticeDtime: moment().format("YYYY-MM-DD"),
      helpDeskNumber: "",
      ciscoWebexHub: "",
    },
  },
  layoutList: [
    {
      text: "All Equal",
      value: "allEqual",
      url: "/static/images/Layouts/allEqual.png",
    },
    {
      text: "Speaker Only",
      value: "speakerOnly",
      url: "/static/images/Layouts/speakerOnly.png",
    },
    {
      text: "Telepresence",
      value: "telepresence",
      url: "/static/images/Layouts/ActivePresence.png",
    },
    {
      text: "Stacked",
      value: "stacked",
      url: "/static/images/Layouts/Prominent.png",
    },
    {
      text: "All Equal Quarters",
      value: "allEqualQuarters",
      url: "/static/images/Layouts/allEqualQuarters.png",
    },
    {
      text: "All Equal Ninths",
      value: "allEqualNinths",
      url: "/static/images/Layouts/allEqualNinths.png",
    },
    {
      text: "All Equal Sixteenths",
      value: "allEqualSixteenths",
      url: "/static/images/Layouts/allEqualSixteenths.png",
    },
    {
      text: "All Equal TwentyFifths",
      value: "allEqualTwentyFifths",
      url: "/static/images/Layouts/allEqualTwentyFifths.png",
    },
    {
      text: "One Plus Five",
      value: "onePlusFive",
      url: "/static/images/Layouts/onePlusFive.png",
    },
    {
      text: "One Plus Seven",
      value: "onePlusSeven",
      url: "/static/images/Layouts/onePlusSeven.png",
    },
    {
      text: "One Plus Nine",
      value: "onePlusNine",
      url: "/static/images/Layouts/onePlusNine.png",
    },
    {
      text: "One Plus N",
      value: "onePlusN",
      url: "/static/images/Layouts/onePlusN.png",
    },
    {
      text: "Automatic",
      value: "automatic",
      url: "/static/images/Layouts/allEqual.png",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/api/index.js